export default __webpack_public_path__ + "static/media/keyboard_arrow_down.fd9d1a29.svg";